module.exports = require("core-js/modules/es.promise.all-settled.js");